










import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import * as types from "@/store/constants/setting_types";
import videoPlayer from "@/components/VideoPlayer/VideoPlayer.vue";
import { vipIsTryForFree } from "@/utils/general_utils";
import VipOfferUtils from "@/utils/vip_util/vip_offer_utils";
import { isIos } from "@/utils/lodash";
@Component({
  components: { videoPlayer }
})
export default class NotVipHeader extends Vue {
  @Getter(types.GETTER_CLIENT_SETTINGS)
  private clientSetting: any;
  private videoUrl: string = "";
  private posterSrc = "";

  get offer() {
    return VipOfferUtils.getVipOneMonthOffer();
  }

  get isShowTryForFree() {
    return vipIsTryForFree(this.offer);
  }

  private async getVideoUrl() {
    // this.videoUrl = "https://cdn.thelire.com/ins/videos/vip_video_one_beta.mp4";
    // const video_url = isIos() ?
    //   "https://cdn.nonfound.com/videos/ins_vip.mp4" :
    //   "https://cdn.thelire.com/ins/videos/vip_video_one_beta.mp4"
    // const videoPathList = video_url.split("/");
    // const videoName = videoPathList[videoPathList.length - 1];
    // this.videoUrl = await handleLocalVideo(video_url, videoName);
    const imgName = "become_vip.jpg";
    this.posterSrc = require("@/assets/icons-file/vip/" + imgName);
    this.videoUrl = isIos()
      ? "https://cdn.nonfound.com/videos/ins_vip.mp4"
      : "https://cdn.thelire.com/ins/videos/vip_video_one_beta.mp4";
  }

  private created() {
    this.getVideoUrl();
  }
}
